// removed by extract-text-webpack-plugin
module.exports = {"shareWrapper":"_1VXc4ZVNiLP0KBj84JyQ-K","row":"_1eKovBWbCseDwq6-QMEcMX","column":"_3GWRBJEbzKHu3SvAIBbr0F","iconWrapper":"_3qE5gLjVp7GYtg_YUGQRE","emailWrapper":"_30sH7juNR80wWv-wqaPIjS","copyLinkWrap":"_3iE_HI_ygGFo0B5nHQSzUz","name":"_2eNi79hbRD1ThB3AOFGAbT","copyWrapper":"U5Ce0LCatU4w-3iH3mUB2","shareRow":"_1cXk3DXtJPJntZdlmBjnDo","shareTitle":"_2gPSj_WpFMeprlvG6dCeGa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareBlock/ShareBlock.scss
// module id = 1778
// module chunks = 0